<template>
  <div class="row">
    <div class="col">
      <label class="col-form-label">Email Address</label>
      <input
        type="text"
        class="form-control"
        placeholder="Email Address"
        :value="filters.email"
        @keyup="e => onValueChanged('email', e.target.value)"
      />
    </div>
    <div class="col">
      <label class="col-form-label">Account Type</label>
      <select
        class="form-control"
        :value="filters.accountType"
        @change="e => onValueChanged('accountType', e.target.value)"
      >
        <option>All</option>
        <option>Speakers</option>
        <option>Non-Speakers</option>
      </select>
    </div>
    <div class="col">
      <label class="col-form-label">Account Permissions</label>
      <select
        class="form-control"
        :value="filters.accountPermissions"
        @change="e => onValueChanged('accountPermissions', e.target.value)"
      >
        <option>All</option>
        <option>Disabled</option>
        <option>Viewer</option>
        <option>Admin</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
